import React from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { SEO } from "@/lib/seo";
import { Sprout, Salad, CalendarCheck, Activity, ShieldCheck, HeartPulse } from "lucide-react";

// Exposed for site search indexer (English source strings).
export const TOPICS = [
    { icon: ShieldCheck, key: "t1" },
    { icon: Salad, key: "t2" },
    { icon: Sprout, key: "t3" },
    { icon: Activity, key: "t4" },
    { icon: CalendarCheck, key: "t5" },
    { icon: HeartPulse, key: "t6" },
];

export default function PreventivePage() {
    const { t } = useTranslation();
    return (
        <>
            <SEO title={t("preventive.seoTitle")} description={t("preventive.seoDescription")} />
            <div className="container-page pt-8">
                <Breadcrumbs items={[{ label: t("preventive.crumb") }]} />
            </div>
            <section className="container-page pt-6 pb-4">
                <div className="max-w-3xl">
                    <span className="chip-teal">{t("preventive.chip")}</span>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--brand-navy)] leading-tight">
                        {t("preventive.title")}
                    </h1>
                    <p className="mt-4 text-[color:var(--text-muted)] leading-relaxed text-lg">
                        {t("preventive.intro")}
                    </p>
                </div>
            </section>

            <section className="container-page pb-4">
                <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {TOPICS.map((topic) => (
                        <div key={topic.key} className="card-soft p-6">
                            <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-teal-soft)] text-[color:var(--brand-teal-2)]">
                                <topic.icon className="h-5 w-5" />
                            </div>
                            <h3 className="mt-4 font-display text-lg font-semibold text-[color:var(--brand-navy)]">{t(`preventive.${topic.key}Title`)}</h3>
                            <p className="mt-2 text-sm text-[color:var(--text-muted)] leading-relaxed">{t(`preventive.${topic.key}Body`)}</p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}
